import { render, staticRenderFns } from "./GalleryList.vue?vue&type=template&id=025238df&"
import script from "./GalleryList.vue?vue&type=script&lang=js&"
export * from "./GalleryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\PhpstormProjects\\warehouse\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('025238df')) {
      api.createRecord('025238df', component.options)
    } else {
      api.reload('025238df', component.options)
    }
    module.hot.accept("./GalleryList.vue?vue&type=template&id=025238df&", function () {
      api.rerender('025238df', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "web/typo3conf/ext/ig_warehouse/Resources/Public/Src/JavaScript/components/gallery/GalleryList.vue"
export default component.exports